import { Button } from '@apollo/orbit';
import * as Sentry from '@sentry/react';
import React from 'react';

import * as orgRoutes from 'src/app/account/routes';
import { usePrivateSubgraphSyncMutation } from 'src/hooks/useCloudResourceManagement';
import { useRouteParams } from 'src/hooks/useRouteParams';
import { CloudProvider } from 'src/lib/graphqlTypes/types';

import { CommonCloudDedicatedProps, CommonStepProps } from '../shared';

export const LinkPrivateResourceButton = ({
  errors,
  values,
  sync,
  sharedResourcesLoading,
  setAvailableUnregisteredResources,
}: Pick<CommonStepProps, 'errors' | 'values'> &
  Pick<CommonCloudDedicatedProps, 'setAvailableUnregisteredResources'> & {
    sync: ReturnType<typeof usePrivateSubgraphSyncMutation>['sync'];
    sharedResources: ReturnType<typeof usePrivateSubgraphSyncMutation>['data'];
    sharedResourcesLoading: ReturnType<
      typeof usePrivateSubgraphSyncMutation
    >['loading'];
  }) => {
  const { orgId } = useRouteParams(orgRoutes.supergraphOnboarding);

  const handleArnSubmit = async () => {
    try {
      const privateSubgraphSyncResult = await sync(
        {
          identifier: values.arn,
          provider: CloudProvider.AWS,
        },
        orgId,
      );

      if (
        !privateSubgraphSyncResult.errors &&
        privateSubgraphSyncResult.data?.account?.privateSubgraph
      ) {
        setAvailableUnregisteredResources(
          privateSubgraphSyncResult.data.account?.privateSubgraph.sync.map(
            (p) => {
              return {
                domainUrl: p.domainUrl,
                name: p.name || '',
                status: p.status,
                region: {
                  name: p.region.name,
                  code: p.region.code,
                },
              };
            },
          ),
        );
      }
    } catch (e) {
      Sentry.captureException(
        new Error(
          `Unable to associate AWS ARN for private subgraph: ${e as Error}`,
        ),
      );
    }
  };

  return (
    <div className="flex justify-end">
      <Button
        type="submit"
        isLoading={sharedResourcesLoading}
        loadingText="Linking"
        onClick={handleArnSubmit}
        isDisabled={!!errors.arn}
      >
        Link my resource
      </Button>
    </div>
  );
};
